import { render, staticRenderFns } from "./Insentif.vue?vue&type=template&id=14442ba7"
import script from "./Insentif.vue?vue&type=script&lang=js"
export * from "./Insentif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports